module.exports = __webpack_public_path__ + "img/thumbnail_AmurLeopard_f_normal.e8e270e1.png";